exports.default = {
  'not_found_message': '繞了地球一圈，還是沒有找到您要的頁面'
}
